// frontend/admin-portal/src/components/users/UserStats.jsx
import React, { useEffect, useState } from "react";
import { Card, Title, Spinner } from "@fiberhome/shared-ui";
import { userService } from "../../services/userService";

export default function UserStats({ refreshKey = 0 }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    userService
      .stats()
      .then((s) => alive && setStats(s))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const cards = [
    { label: "Total Users", value: stats?.total ?? "—" },
    {
      label: "Active",
      value: stats?.active ?? "—",
      color: "var(--fh-success)",
    },
    { label: "Inactive", value: stats?.inactive ?? "—" },
    { label: "Locked", value: stats?.locked ?? "—", color: "var(--fh-danger)" },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((c) => (
        <div className="col-md-3 col-sm-6" key={c.label}>
          <Card hoverable>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {c.label}
            </div>
            <Title
              level={2}
              className="mb-0"
              style={c.color ? { color: c.color } : undefined}
            >
              {loading ? <Spinner size="md" /> : c.value}
            </Title>
          </Card>
        </div>
      ))}
    </div>
  );
}
